export default __webpack_public_path__ + "static/media/watches2.65ae124e.jfif";